import { injectIntl } from '@atlassian/jira-intl';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getLead } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import LeadView from './view.tsx';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	user: getLead(state, ownProps.componentId),
});

export default connect(mapStateToProps, {})(injectIntl(LeadView));
